import { ConfigurationOntology } from '@/modules/configurationModule/shared/components/configuration-ontologies/configuration-ontologies.model'
import { store } from '@/store/store'

export interface ConfigurationOntologySynopticTemplate extends ConfigurationOntology {
    synopticTemplateId: number
}

export interface ConfigurationTemplatesSynopticTemplatesModalOntologiesState {
    ontologies: ConfigurationOntologySynopticTemplate[]
    laboratoryId: number
}
export const initialConfigurationTemplatesSynopticTemplatesModalOntologiesState =
    (): ConfigurationTemplatesSynopticTemplatesModalOntologiesState => ({
        ontologies: [],
        laboratoryId: store.getters.labId
    })
